// extracted by mini-css-extract-plugin
export default {"home":"Home_home__ncRbW","prevent-text-selection":"Home_prevent-text-selection__Qjl8R","icon":"Home_icon__7HEeG","links":"Home_links__-Btgj"};